'use client';

import { cn } from '@/lib/utils';

export type ChatContainerProps = {
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  scrollToRef?: React.RefObject<HTMLDivElement | null>;
  contentRef?: React.RefObject<HTMLDivElement | null>;
  ref?: React.RefObject<HTMLDivElement | null>;
} & React.HTMLAttributes<HTMLDivElement>;

// Presentational scroll surface only. Messages live in an inner wrapper so a
// ResizeObserver in the owning component can watch the transcript's height
// without the scroller's own fixed box masking the change.
export function BaseContainer({
  className,
  contentClassName,
  children,
  scrollToRef,
  contentRef,
  ref,
  ...props
}: ChatContainerProps) {
  return (
    <div
      className={cn(
        'flex min-w-0 flex-col overflow-y-auto overflow-x-hidden',
        className
      )}
      role='log'
      ref={ref}
      {...props}
    >
      <div
        ref={contentRef}
        className={cn('flex shrink-0 flex-col', contentClassName)}
      >
        {children}
      </div>
      <div
        ref={scrollToRef}
        className='h-px w-full flex-shrink-0'
        aria-hidden='true'
      />
    </div>
  );
}
